import './map.scss';
import $ from "jquery";

class MapSection {
	constructor() {
		$('.map-nav__item').on('click', this.changeLocation);
	}

	changeLocation = (e) => {
		const dataOffice = $(e.target).data('office');
		let dataAddress = $(e.target).data('address');
		dataAddress = dataAddress.replace(/(?:\r\n|\r|\n)/g, '<br>');
		const lat = parseFloat($(e.target).data('lat'));
		const lng = parseFloat($(e.target).data('long'));

		//change active class
		$('.map-nav__item').removeClass('active');
		$(e.target).addClass('active');

		//change text in sidebar
		$('.office__name').html(dataOffice);
		$('.office__address').html(dataAddress);

		this.moveBus(lat, lng);
	};

	initMap = () => {
		const position = {
			lat: parseFloat(websiteData.init_lat),
			lng: parseFloat(websiteData.init_lng),
		};

		this.map = new google.maps.Map(document.getElementById("mapJs"), {
			zoom: 4,
			center: position,
			fullscreenControl: false,
		});

		this.marker = new google.maps.Marker({
			position,
			map: this.map,
		});
	}

	moveBus = (lat, lng) => {
		this.marker.setPosition(new google.maps.LatLng(lat, lng));
		this.map.panTo(new google.maps.LatLng(lat, lng));
	}
}

const googleMapSP = new MapSection();
window.initMap = googleMapSP.initMap;
